import { CardType, ICreditCard } from '@/shared/endpoints/customers';
import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';

import MasterIcon from '@/assets/icons/credit-card/master.svg';
import VisaIcon from '@/assets/icons/credit-card/visa.svg';
import AmexIcon from '@/assets/icons/credit-card/amex.svg';
import DiscoverIcon from '@/assets/icons/credit-card/discover.svg';
import { getCreditCardName } from '@/shared/helpers/credit-card';

interface IProps {
    list: ICreditCard[];
    className?: string;
}

const CardList = ({ list, className = '' }: IProps) => {
    const cardImages: Record<CardType, string> = {
        visa: VisaIcon,
        mastercard: MasterIcon,
        discover: DiscoverIcon,
        // amex: AmexIcon,
        'american-express': AmexIcon
    };

    const getSourceForCardType = (type: CardType) => cardImages[type] || '';

    return list.map(({ id, lastFourDigit, expiryYear, expiryMonth, brand }) => {
        const source = getSourceForCardType(brand);
        return (
            <div className={`${className} flex w-full flex-row items-center justify-start py-4 px-5 bg-mint-700 rounded-[0.8125rem]`} key={id}>
                {source && (
                    <img
                        width={78}
                        className="card-icon min-w-[4.875rem] mr-4"
                        src={source}
                        alt={brand}
                    />
                )}

                <div className="flex w-full flex-row justify-start items-center">
                    <div className="flex w-full flex-col">
                        <span>
                            <b>
                                {getCreditCardName(brand)} ending in {lastFourDigit}
                            </b>
                        </span>
                        <div className="flex w-full flex-row justify-between">
                            <span className="expiry">
                                Expires {expiryMonth}/{expiryYear}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    });
};

export default withScrollRestoration(CardList);
